import { Col, Row, Timeline} from 'antd';
import React, { ReactElement, useState} from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store';
import { getDefaultStr } from '../../../../service/crmUtils';
import NumberFormatView from '../../../../../../../shared/components/NumberFormatView/NumberFormatView';
import { getDateWithTime } from '../../../../../../../utils/dateTimeUtils';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../../../../../shared/constants/commonConstants';
import Modal from 'antd/lib/modal/Modal';
import Text from 'antd/lib/typography/Text';
import { courierProviders } from '../../../../../../../shared/constants/commonConstants';
import './ClaimDetailHeader.less';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import { canActivate, isSuperAdmin } from '../../../../../../../utils/utility';
const ClaimDetailHeader = ({ noTopClass, newDoa, newDod, isShowPayer}: any): ReactElement => {
  const { claimDetails, isCashlessSubmit } = useSelector((state: RootState): any => state.admissionDetails);
  const {
    approvedAmount, payerClaimNo, doa, dod, claimedAmount,
    transactionId, transactionAmount, payerId, courierTrackId, courierProvider, courierStatus, hospActionId,
    payerType,
  } = claimDetails;
  const appDetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const dateOfAdmission = getDateWithTime(newDoa || doa);
  const dateOfDischarge = getDateWithTime(newDod || dod);
  const [courierStatusActive, setCourierStatusActive] = useState(false);

  const openModal = (): void => {
    setCourierStatusActive(true);
  };
  const closeModal = (): any => {
    setCourierStatusActive(false);
  };

  const checkCourierProvider = (): boolean => {
    let checkValid = false;
    let countValid = 0;

  courierProviders?.map((ele?: any): any => {
    countValid = (courierProvider === ele || courierProvider === null) ? countValid + 1 : countValid;
  });
    countValid > 0 ? checkValid = true : checkValid = false;
    return checkValid;
  };

  return (
    <>
    <Col>
    <Row gutter={GUTTOR_SPACE}>
    <div className={`claim-details ${noTopClass ? 'no-margin' : ''}`} data-testid="claim-detail-header">
      <Col md={8}>
        <p className="label-title">Claim No.</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(payerClaimNo)}</div>
      </Col>
      <Col md={8}>
        <p className="label-title">Date of Admission</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(dateOfAdmission, true)}</div>
      </Col>
      <Col md={8}>
        <p className="label-title">Date of Discharge</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(dateOfDischarge, true)}</div>
      </Col>
      <Col md={8}>
        <p className="label-title">Claimed Amount</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm">
          <NumberFormatView amount={claimedAmount} prefix={'₹ '} fixedDecimalScale={true} />
        </div>
      </Col>
      <Col md={8}>
        <p className="label-title">Approved Amount</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm">
          <NumberFormatView amount={approvedAmount} prefix={'₹ '} fixedDecimalScale={true} />
        </div>
      </Col>
     {isSuperAdmin() && canActivate(authFeatureConstants.CHANGE_HOSPITAL) && hospActionId && <Col md={8}>
      <p className="label-title">Hospaction ID</p>
        <div data-testid="claimDetailHeader" className="label-value fsize_sm">
        {getDefaultStr(hospActionId, true)}
        </div>
      </Col> // adding hospaction id for super admin users
      }
      {courierProvider === 'Hand Delivery' ?  <Col md={8}>
        <p className="label-title">Receipt Number</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">
          {getDefaultStr(courierTrackId, true)}
        </div>
      </Col> :
      <Col md={8}>
        <p className="label-title">Courier Tracking/ Acknowledgement Number</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">
          {getDefaultStr(courierTrackId, true)}
        </div>
      </Col>
      }
      <Col md={8}>
        <p className="label-title">Courier Provider Service</p>
        <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">
          {getDefaultStr(courierProvider, true)}
        </div>
      </Col>
      <Col md={8}>
        <p className="label-title">Courier Status</p>

         {(isCashlessSubmit ? Array(courierStatus) : courierStatus)?.length === 0 && !checkCourierProvider() &&
         <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">
          Tracking unavailable for {courierProvider || 'selected'} Courier Provider </div>}
          {courierProvider === 'Hand Delivery' &&
           <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">
           Tracking not applicable for hand delivery </div>
          }
              <a data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm" onClick={openModal}>
                {(isCashlessSubmit && courierStatus != null
                  ? (Array.isArray(courierStatus) ? courierStatus : [courierStatus])
                  : []
                )?.map((ele: any, index: number): ReactElement => {
                  return (index === 0) ? <span key={index}>{ele?.status}</span> : <span />;
                })}
              </a>
      </Col>
      {
        transactionAmount ? <Col md={8}>
          <p className="label-title">Settled Amount</p>
          <div data-testid="claimDetailHeader" className="label-value fsize_sm">
            <NumberFormatView amount={transactionAmount} prefix={'₹ '} fixedDecimalScale={true} />
          </div>
        </Col> : null
      }
      {
        transactionId ? <Col md={8}>
          <p className="label-title">UTR No.</p>
          <div data-testid="claimDetailHeader" className="label-value fsize_sm">
            {getDefaultStr(transactionId)}
          </div>
        </Col> : null
      }
      {
        isShowPayer && payerId ? <Col md={8}>
          <p className="label-title">Payer</p>
          <div data-testid="claimDetailHeader" className="label-value fsize_sm">
            {getDefaultStr(payerId)}
                </div>
                </Col> : null
      }
      {isSuperAdmin() && canActivate(authFeatureConstants.CHANGE_HOSPITAL) && (
              <Col md={8}>
                <p className="label-title">Channel</p>
                <div data-testid="claimDetailHeader" className="label-value fsize_sm">
                  {`${payerType === 'RPAPayor' ? 'RPA' : payerType === 'MultiPayer' ?
                    'Email' : payerType === 'IntegrationPayer' ? 'Direct' : '-'}${claimDetails?.isNHCXClaimFlow ? '/NHCX' : ''}`}
                </div>
              </Col>
      )}
      {isSuperAdmin() && (
        <Col md={8}>
          <p className="label-title">IHX Provider ID</p>
          <div data-testid="claimDetailHeader" className="label-value fsize_sm">
            {getDefaultStr(appDetails?.getProviderId())}
          </div>
        </Col>
      )}
  </div>
          <Modal
            visible={courierStatusActive}
            footer={null}
            onCancel={closeModal}
            title={<h2>Courier Timeline</h2>}
          >
            <Timeline>
              {
                (isCashlessSubmit && courierStatus != null
                  ? (Array.isArray(courierStatus) ? courierStatus : [courierStatus])
                  : [])?.map((ele: any, index: number): ReactElement => {
                  return (index === 0) ? <Timeline.Item key={index}>
                    <span className="selected-status">
                      <span className="bold">{ele?.status}
                      <p className="location-container"><Text type="secondary" className="fsize_sm">{ele?.location}</Text></p></span>
                      <span className="tab-space"> {getDateWithTime(ele?.statusDate)}</span>
                    </span>
                  </Timeline.Item> :
                    <Timeline.Item>
                       <span className="bold">{ele?.status}<p className="location-container">
                        <Text type="secondary" className="fsize_sm">{ele?.location}</Text></p>
                       </span><span className="tab-space"> {getDateWithTime(ele?.statusDate)}
                       </span>
                    </Timeline.Item>;
                })
              }
            </Timeline>
          </Modal>
        </Row>
</Col></>
);
};

export default ClaimDetailHeader;
